import { Controller } from "@hotwired/stimulus"

// Applies the recipe page's custom title / headings / body text colors by setting
// CSS custom properties (CSP-safe, no inline style) that the .recipe-*-tint classes
// read. Font and size are safelisted utility classes rendered server-side; only the
// hex colors need a variable. Re-applied on every Turbo render — a morph refresh
// wipes the inline vars and doesn't re-run connect() (same as cover-plate).
export default class extends Controller {
  static values = { titleColor: String, headingsColor: String, bodyColor: String }

  connect() {
    this.apply()
  }

  apply() {
    this.set("--recipe-title-color", this.titleColorValue)
    this.set("--recipe-headings-color", this.headingsColorValue)
    this.set("--recipe-body-color", this.bodyColorValue)
  }

  set(name, value) {
    if (value) this.element.style.setProperty(name, value)
    else this.element.style.removeProperty(name)
  }
}
